import { createApp } from 'vue'
import { createPinia } from 'pinia'
// piniaの永続化ライブラリ
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import App from './App.vue'
import router from './router'

// [MiiaFW] bootstrap
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-umi/dist/css/bootstrap.min.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import { createBootstrap } from 'bootstrap-vue-next'

import '@/assets/css/miiaFw/ff-parts.css'

// [MiiaFW] Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// [MiiaFW] Ajax通信ライブラリ
import axios from 'axios'

// 多言語対応
import { createI18n } from 'vue-i18n'
import { data } from '@/libs/lang'

const app = createApp(App)

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
app.use(pinia)
app.use(router)
app.use(createBootstrap())

// [MiiaFW] Font Awesome
library.add(fas)
library.add(fab)
library.add(far)
app.component('font-awesome-icon', FontAwesomeIcon)

// [MiiaFW] Ajax通信ライブラリ
app.provide('axios', axios)

// 多言語対応
const i18n = createI18n({
  legacy: false,
  locale: 'ja', // デフォルト言語設定
  fallbackLocale: 'ja', // 選択中の言語に対応する文字列が存在しない場合はこの言語の文字列を使用する
  messages: data
})
app.use(i18n)

// [MiiaFW]グローバルディレクティブ
// 紐付いている要素がDOMに挿入される時、当該要素にフォーカスが当たる。
app.directive('focus', {
  mounted: el => {
    el.focus()
  }
})

// -------------------- history -> hash変換時にコメントアウト Start -------------------- //

// ページ遷移後処理
router.afterEach(to => {
  // 戻るボタンを無効化するために履歴に自ページを追加
  let path = to.path
  if (Object.keys(to.query).length > 0) {
    Object.keys(to.query).forEach((key, index) => {
      if (index === 0) {
        path += '?'
      } else {
        path += '&'
      }

      path += `${key}=${to.query[key]}`
      if (index + 1 === Object.keys(to.query).length) {
        window.history.pushState(null, '', window.location.origin + path)
      }
    })
  } else {
    window.history.pushState(null, '', window.location.origin + path)
  }
})

// 戻るボタンを押下時に自ページを履歴に追加することで戻るボタンを無効化
window.addEventListener('popstate', () => {
  window.history.pushState(null, '', window.location.href)
})
// -------------------- history -> hash変換時にコメントアウト End -------------------- //

app.mount('#app')
